module.exports = __webpack_public_path__ + "img/13step-04-1_ergebnis.86eba56d.webp";